import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const GenderToggle = ({
  value,
  onChange,
  disabled = false,
  storageKey = 'hs_gender',
  showOther = true,
  options: optionsOverride
}) => {
  const { t } = useTranslation('admin');

  const DEFAULT_OPTIONS = [
    { value: 'men', labelKey: 'admin.gender_man', iconSrc: '/images/icons/male-gender.png' },
    { value: 'women', labelKey: 'admin.gender_woman', iconSrc: '/images/icons/female.png' },
    { value: 'other', labelKey: 'admin.gender_other', iconSrc: '/images/icons/third-gender.png' }
  ];

  const baseOptions = showOther ? DEFAULT_OPTIONS : DEFAULT_OPTIONS.filter(o => o.value !== 'other');
  const options = (Array.isArray(optionsOverride) && optionsOverride.length > 0)
    ? optionsOverride
    : baseOptions;

  const handleChange = (newValue) => {
    if (disabled) return;
    onChange(newValue);
    try {
      localStorage.setItem(storageKey, newValue);
    } catch (e) {}
  };

  return (
    <div className="w-full">
      <div className="bg-zinc-100 dark:bg-zinc-800 p-1 rounded-xl flex gap-1">
        {options.map((option) => {
          const isSelected = value === option.value;
          const label = option.labelKey ? t(option.labelKey) : option.label;
          return (
            <motion.button
              key={option.value}
              type="button"
              onClick={() => handleChange(option.value)}
              disabled={disabled}
              aria-label={label}
              aria-pressed={isSelected}
              className={`
                flex-1 py-3 px-4 rounded-lg font-medium text-sm transition-all duration-200
                flex items-center justify-center gap-2
                ${isSelected 
                  ? 'bg-white dark:bg-zinc-700 text-[#7d6633] shadow-md ring-1 ring-[#7d6633]/30' 
                  : 'text-zinc-600 dark:text-zinc-400 hover:text-[#7d6633] dark:hover:text-[#7d6633] active:text-[#7d6633] dark:active:text-[#7d6633]'
                }
                ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
              `}
              whileHover={!disabled ? { scale: 1.02 } : {}}
              whileTap={!disabled ? { scale: 0.98 } : {}}
            >
              <img
                src={option.iconSrc}
                alt=""
                aria-hidden="true"
                className="h-5 w-5 object-contain dark:brightness-0 dark:invert"
                draggable={false}
              />
              <span>{label}</span>
            </motion.button>
          );
        })}
      </div>
    </div>
  );
};

export default GenderToggle;
